import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function UserListFetchError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot get user data'}
    </Alert>
  );
}

export { UserListFetchError };